export default __webpack_public_path__ + "static/media/package-b.5ec1846a.jpg";